export default __webpack_public_path__ + "static/media/desc.1e33a0bd.svg";